<template>
  <transition name="cycleFromLeft" mode="out-in">
    <div class="power vh-for-mobile" :data-variant="variant">

      <div class="wrapper">

        <div class="power__content">
          <div v-if="config.fullText" class="power__fullText" v-html="config.fullText"></div>
        </div>

        <div class="wrapper__right">
          <div class="power__input">

            <div v-if="config.shortText" class="power__shortText" v-html="config.shortText"></div>
            <transition name="fadeFromTop" mode="in-out">
              <label>
                <input id="power-1" type="number" @keyup="checkIfPopulated"/>
                <div></div>
              </label>
            </transition>

            <div v-if="hasOverlay" class="power__info" @click="openInfoOverlay">
              <img :src="returnBasePath('/assets/img/shared/icon-help.png')" alt="Info"/>
              <span>{{config.info.label}}</span>
            </div>

          </div>

          <transition name="slideLeft" mode="out-in">
            <div v-if="config.answers" class="power__answers">

              <div v-for="item in config.answers"
                   :key="item.id"
                   :class="{'power__answers__item': true, 'is-disabled': !filledInput}"
                   @click="retrieveNextStep(config.id, item.id, item.disabled)">
                <img v-if="item.icon" :src="item.icon" :alt="item.text"/>
                <span class="power__answers__item__span">{{item.text}}</span>

                <div v-if="item.info" class="power__answers__item__info">
                  <img :src="returnBasePath('/assets/img/shared/icon-help.png')" alt="Info"/>
                  <span>{{item.info.label}}</span>
                </div>
              </div>

            </div>
          </transition>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

  export default{
    props: ['dataObj', 'currentVariant'],
    data(){
      return {
        config: {},
        variant: this.currentVariant,
        hasInfo: false,
        power: false,
        inputLength: 0
      }
    },
    watch: {
      currentVariant(){
        this.variant = this.currentVariant;
      }
    },
    computed: {
      hasOverlay(){
        return this.config.info && this.config.info.type == 'overlay';
      },
      filledInput(){
        return this.power;
      }
    },
    methods: {
      checkIfOverflow(){
        var viewHeight = $('.power').innerHeight();
        var windowHeight = $(window).innerHeight();
        var footerHeight = $('.footer').innerHeight();
        var headerHeight = $('.header').innerHeight();
        var visibleHeight = windowHeight - footerHeight - headerHeight;
        if (viewHeight > visibleHeight) {
          $('.power').addClass('has-overflow');
        }
      },
      checkIfPopulated(){
        var inputLength = $('#power-1').val().length;
        this.power = inputLength > 0;
      },
      validatePower(evt){
        evt = (evt) ? evt : window.event;
        var vm = this;
        var inputLength = $('#power-1').val().length;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode !== 8 && charCode !== 127 && charCode !== 37 && charCode !== 39) {
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();
          } else {
            if (inputLength < 5) {
              vm.inputLength = inputLength + 1;
            }
            else {
              evt.preventDefault();
            }
          }
        }
        else {
          vm.inputLength = inputLength + 1;
          return true;
        }
      },
      openInfoOverlay(){
        var vm = this;
        if (vm.config.info.type == 'overlay') {
          vm.$emit('open-overlay', vm.config.info);
        }
      },
      beforeEnter(){
        $('.power__answers__item').addClass('slideLeft-enter');
      },
      enter(){
        $('.power__answers__item').removeClass('slideLeft-enter');
      },
      leave(){
      },
      afterLeave(){
      },
      updateProps(){
        //Update component data when component is mounted or updated
        this.config = this.dataObj;
      },
      updateParentProps(){
        // Emits response from @retrieveNextStep(), precedently saved in Vue store, to parent component @App.vue
        var vm = this;
        var config = vm.$store.state.tempConfigObj;
        if (config) {
          vm.$emit('update-props', config);
          this.$forceUpdate();
        }
      },
      retrieveNextStep(powerId, answerId, isDisabled){
        var value = $('#power-1').val() + '';
        if (!isDisabled) {
          // Make AJAX call to retrieve next power node
          // @powerId {integer}:
          //    is the current node ID
          // @answerId {integer}:
          //    is the chosen answer ID
          // @value {String}:
          //    is the inputted values, formatted as such, e.g: ('7,7')
          var vm = this;
          for (var i = 0; i < vm.config.answers.length; i++) {
            vm.config.answers[i].disabled = true;
          }
          vm.makeNextCall(powerId, answerId, function () {
            vm.updateParentProps();
          }, value)
        }
      }
    },
    mounted(){
      var vm = this;
      vm.updateProps();
    },
    updated(){
      var vm = this;
      vm.updateProps();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/input/Power.vue